import { mapExchange } from '@urql/core';
import { print } from 'graphql';
import { getUrqlTenantCompanyId, mergeTenantVariables } from './tenantCompanyId';

function operationQueryText(operation) {
  try {
    if (!operation?.query) return '';
    return print(operation.query);
  } catch {
    return String(operation?.query ?? '');
  }
}

/** Inyecta companyId en variables cuando la operación declara $companyId (A-02 T4). */
export function tenantCompanyExchange() {
  return mapExchange({
    onOperation(operation) {
      const companyId = getUrqlTenantCompanyId();
      if (!companyId) return operation;

      const vars = operation.variables || {};
      if (vars.companyId != null && vars.companyId !== '') return operation;

      const queryText = operationQueryText(operation);
      if (!/\$companyId\b/.test(queryText)) return operation;

      return {
        ...operation,
        variables: mergeTenantVariables(vars, companyId),
      };
    },
  });
}

/** Para client.query / client.mutation imperativos fuera de hooks. */
export function tenantVariablesForQuery(queryDocument, variables) {
  let queryText = '';
  try {
    queryText = print(queryDocument);
  } catch {
    queryText = String(queryDocument ?? '');
  }
  if (!/\$companyId\b/.test(queryText)) return variables || {};
  return mergeTenantVariables(variables, getUrqlTenantCompanyId());
}
